import axios from 'axios';
import getKsBridge from '@/client/utils/bridge';
const request = axios.create();
request.interceptors.response.use(async (response) => {
  const ksBridge = await getKsBridge();
  if (response.status === 200) {
    if (response.data.result === 109 || response.data.result === 6002) {
      ksBridge &&
        ksBridge.login({
          success: () => window.location.reload(),
        });
    }
    return Promise.resolve(response.data);
  } else {
    // eslint-disable-next-line no-console
    console.error(response);
    return Promise.reject(response);
  }
});

export default request;
